import React from 'react';
import Home from './components/home';
import { ConfigProvider } from './context/ConfigContext';

const App = () => {
  return (
    <div className="App">
      <ConfigProvider>
        <Home />
      </ConfigProvider>
    </div>
  );
};

export default App;
